import { Stack, useMediaQuery } from '@mui/material';
import { Skeleton } from 'components/common/skeleton';

export const LoadingData = () => {
  const isDesktop = useMediaQuery('(min-width:1024px)');

  const Section = () => {
    return (
      <Stack direction={isDesktop ? 'row' : 'column'} spacing={isDesktop ? 3 : 0}>
        <Stack spacing={-1.5} width={isDesktop ? '50%' : '100%'}>
          <Skeleton animation="wave" height={20} width="30%" />
          <Skeleton animation="wave" height={80} />
        </Stack>
        <Stack spacing={-1.5} width={isDesktop ? '50%' : '100%'}>
          <Skeleton animation="wave" height={20} width="30%" />
          <Skeleton animation="wave" height={80} />
        </Stack>
      </Stack>
    );
  };
  return (
    <Stack marginTop="15px">
      <Section />
      {isDesktop && <Section />}
    </Stack>
  );
};
